module.exports = __webpack_public_path__ + "static/img/ys_2.c8643e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/ys_2.png
// module id = KEE+
// module chunks = 1